export var CustomerCategoryOld;
(function (CustomerCategoryOld) {
    CustomerCategoryOld["Restaurant"] = "Restaurant";
    CustomerCategoryOld["FastFood"] = "FastFood";
    CustomerCategoryOld["Shop"] = "Shop";
    CustomerCategoryOld["Bar"] = "Bar";
    CustomerCategoryOld["Catering"] = "Catering";
})(CustomerCategoryOld || (CustomerCategoryOld = {}));
export var CustomerCategory;
(function (CustomerCategory) {
    CustomerCategory["Restaurant"] = "Restaurant";
    CustomerCategory["FastFood"] = "FastFood";
    CustomerCategory["Shop"] = "Shop";
    //Bar = "Bar",
    //Catering = "Catering"
})(CustomerCategory || (CustomerCategory = {}));
export class CustomerCategoryHelper {
    static getName(category, i18n) {
        switch (category) {
            case CustomerCategory.Restaurant: return i18n.t('categories.restaurant');
            case CustomerCategory.FastFood: return i18n.t('categories.fastFood');
            case CustomerCategory.Shop: return i18n.t('categories.shop');
        }
    }
}
//# sourceMappingURL=CustomerCategory.js.map